import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Navigate, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { UserContext } from '../../App';
import { ShippingOptions } from '../../components/dashboard/checkout/steps/shipping/shippingOptions';
import { BookOverview } from '../../components/dashboard/soldBook/bookOverview';
import CheckoutBox from '../../components/dashboard/checkout/steps/overview/checkoutBox';
import { LoadingFull } from '../../components/loading';
import { Basket } from '../../components/dashboard/checkout/basket';
import SideBar from '../../components/dashboard/checkout/sideBar';
import { useCheckout } from '../../components/dashboard/checkout/functions/useCheckout';
import Modal from '../../components/login/modal';
import AllForms from '../../components/login/allForms';

const Checkout = () => {

  const [data, setData] = useState()
  const { shipment, setShipment, error_shipment, setError_Shipment, handleBuy, load, openLogin, setOpenLogin, address, setAddress, getServicePoints, servicePoints } = useCheckout()

  useEffect(() => {
    if (localStorage.getItem('basket') !== null && localStorage.getItem('basket') !== '') {
      axios({
        method: 'post',
        url: '/api/findBooks',
        data: {
          'dbIds': localStorage.getItem('basket')
        }
      })
      .then(response => {
        setData(response.data);
      })
      .catch(error => {
        localStorage.setItem('basket', '')
        console.log(error);
      });
    } else {
      setData([])
    }
  }, [])

  useEffect(() => {
    if (typeof data !== 'undefined') {
      const shipments = []
      data.map((book) => {
        if (!shipments.some(a => a.seller === book.dbBook.ejer)) {
          shipments.push({
            'seller': book.dbBook.ejer,
            'products': [book],
            'deliveryType': 1,
            'price': 39,
            'pickup': {
              'available': book.buyBook.pickup,
              'pickup_address': book.soldBook.pickup_address
            },
            'service_point': {}
          })
        } else {
          const ss = shipments.find(a => a.seller === book.dbBook.ejer)
          ss.products.push(book)
        }
      })
      setShipment(shipments)
    }
  }, [data])

  return (
    (typeof data !== 'undefined') ?
      <>
        <div className="innerContainer mx-auto min-h-lvh py-[75px]">
          <div className="flex w-full h-full">
            <div className="flex flex-col lg:flex-row gap-4 w-full">
              <Basket data={data} setData={setData} shipment={shipment} setShipment={setShipment} error_shipment={error_shipment} setError_Shipment={setError_Shipment} address={address} setAddress={setAddress} getServicePoints={getServicePoints} servicePoints={servicePoints} />
              <hr className="lg:hidden"></hr>
              <CheckoutBox data={data} shipment={shipment} handleBuy={handleBuy} load={load} />
            </div>
          </div>
        </div>
        <Modal open={openLogin} onClose={() => setOpenLogin(false)}>
          {openLogin ?
            <AllForms address={address} setAddress={setAddress} handleBuy={handleBuy} />
          :
            ""}
        </Modal>
      </>
    :
      <div className="h-lvh w-full">
        <LoadingFull />
      </div>
  )
}


export default Checkout;